import React from "react";

function Forum() {
  return <div>Forum Page</div>;
}

export default Forum;
